import { bonusTrx, gameInfoTrx, infoTrx, paymentTrx, promoTrx } from '../router-translation.labels';

export const NOT_A_LINK_BREADCRUMB = [
  infoTrx,
  bonusTrx,
  paymentTrx,
  promoTrx,
  gameInfoTrx
];
